module.exports = __webpack_public_path__ + "img/Haiti.772e160d.png";